import SpaceBetween from "@cloudscape-design/components/space-between";
import {
  Box,
  Table,
  Button,
  TextFilter,
  Pagination,
  CollectionPreferences,
  ColumnLayout,
  Container,
  Header,
  Link,
  StatusIndicator,
  AppLayout,
  BreadcrumbGroup,
  ContentLayout,
  HelpPanel,
  Icon,
  SplitPanel,
  Spinner,
} from "@cloudscape-design/components";

import Grid from "@cloudscape-design/components/grid";

import { useEffect, useState } from "react";

import { Amplify } from "aws-amplify";
import config from "../../../amplifyconfiguration.json";
import { Navigation } from "../../../components/app/Navigation";
import React from "react";

//
import { generateClient } from "aws-amplify/api";
import { listSensors } from "../../../graphql/queries";
import { onCreateSensorValue } from "../../../graphql/subscriptions";
import { SensorData, SensorState } from "./data/data";
//import ListTenant from "./components/ListTenant";

Amplify.configure(config);

function DashboardBackend() {
  const [activeHref, setActiveHref] = React.useState("/backend");
  const [sensorData, setSensorData] = useState<SensorState>({
    "sensor-sf-west": null,
    "sensor-sf-east": null,
    "sensor-sf-southeast": null,
    "sensor-sf-southwest": null,
    "sensor-sf-north": null,
  });

  //get first data
  useEffect(() => {
    getFirstData();
  }, []);

  async function getFirstData() {
    const client = generateClient();
    const response = await client.graphql({ query: listSensors });
    console.log("API Response:", response);
  }
  //graphql apis
  useEffect(() => {
    const client = generateClient();
    const createSub = client.graphql({ query: onCreateSensorValue }).subscribe({
      next: ({ data }) => {
        const sensorValue = data.onCreateSensorValue;
        console.log("API Subscribe:", data);
        // Update state based on sensorId with all relevant data
        setSensorData((prevState) => ({
          ...prevState,
          [sensorValue.sensorId]: {
            temperature: sensorValue.temperature,
            disolvedO2: sensorValue.disolvedO2,
            pH: sensorValue.pH,
            salinity: sensorValue.salinity,
            status: sensorValue.status,
          },
        }));
      },
      error: (error) => console.warn(error),
    });
    return () => {
      createSub.unsubscribe();
    };
  }, []);

  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              { text: "Dashboard", href: "/backend" },
              { text: "Home", href: "#" },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }}
          />
        }
        content={
          <ContentLayout header={<Header variant="h1">Backend Service</Header>}>
            <Grid
              gridDefinition={[
                { colspan: { default: 12, xxs: 12 } },
                { colspan: { default: 12, xxs: 12 } },
                { colspan: { default: 12, xxs: 12 } },
              ]}
            >
              <Container
                header={
                  <Header
                    variant="h2"
                    description="List RealTime Data From IoT Data"
                  >
                    Real Time Temperature
                  </Header>
                }
                fitHeight={true}
              >
                <ColumnLayout
                  columns={5}
                  variant="text-grid"
                  minColumnWidth={100}
                >
                  <div>
                    <Box variant="awsui-key-label">SF Bay - West</Box>
                    <h1>
                      {sensorData["sensor-sf-west"] !== null
                        ? sensorData["sensor-sf-west"].temperature + " C"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - East</Box>
                    <h1>
                      {sensorData["sensor-sf-east"] !== null
                        ? sensorData["sensor-sf-east"].temperature + " C"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - SouthEast</Box>
                    <h1>
                      {sensorData["sensor-sf-southeast"] !== null
                        ? sensorData["sensor-sf-southeast"].temperature + " C"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - Southwest</Box>
                    <h1>
                      {sensorData["sensor-sf-southwest"] !== null
                        ? sensorData["sensor-sf-southwest"].temperature + " C"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - North</Box>
                    <h1>
                      {sensorData["sensor-sf-north"] !== null
                        ? sensorData["sensor-sf-north"].temperature + " C"
                        : "Loading..."}
                    </h1>
                  </div>
                </ColumnLayout>
              </Container>
              <Container
                header={
                  <Header
                    variant="h2"
                    description="List RealTime Data From IoT Data"
                  >
                    Real Time pH
                  </Header>
                }
                fitHeight={true}
              >
                <ColumnLayout
                  columns={5}
                  variant="text-grid"
                  minColumnWidth={100}
                >
                  <div>
                    <Box variant="awsui-key-label">SF Bay - West</Box>
                    <h1>
                      {sensorData["sensor-sf-west"] !== null
                        ? sensorData["sensor-sf-west"].pH + " %"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - East</Box>
                    <h1>
                      {sensorData["sensor-sf-east"] !== null
                        ? sensorData["sensor-sf-east"].pH + " %"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - SouthEast</Box>
                    <h1>
                      {sensorData["sensor-sf-southeast"] !== null
                        ? sensorData["sensor-sf-southeast"].pH + " %"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - Southwest</Box>
                    <h1>
                      {sensorData["sensor-sf-southwest"] !== null
                        ? sensorData["sensor-sf-southwest"].pH + " %"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - North</Box>
                    <h1>
                      {sensorData["sensor-sf-north"] !== null
                        ? sensorData["sensor-sf-north"].pH + " %"
                        : "Loading..."}
                    </h1>
                  </div>
                </ColumnLayout>
              </Container>
              <Container
                header={
                  <Header
                    variant="h2"
                    description="List RealTime Data From IoT Data"
                  >
                    Real Time Salinity
                  </Header>
                }
                fitHeight={true}
              >
                <ColumnLayout
                  columns={5}
                  variant="text-grid"
                  minColumnWidth={100}
                >
                  <div>
                    <Box variant="awsui-key-label">SF Bay - West</Box>
                    <h1>
                      {sensorData["sensor-sf-west"] !== null
                        ? sensorData["sensor-sf-west"].salinity + " %"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - East</Box>
                    <h1>
                      {sensorData["sensor-sf-east"] !== null
                        ? sensorData["sensor-sf-east"].salinity + " %"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - SouthEast</Box>
                    <h1>
                      {sensorData["sensor-sf-southeast"] !== null
                        ? sensorData["sensor-sf-southeast"].salinity + " %"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - Southwest</Box>
                    <h1>
                      {sensorData["sensor-sf-southwest"] !== null
                        ? sensorData["sensor-sf-southwest"].salinity + " %"
                        : "Loading..."}
                    </h1>
                  </div>
                  <div>
                    <Box variant="awsui-key-label">SF Bay - North</Box>
                    <h1>
                      {sensorData["sensor-sf-north"] !== null
                        ? sensorData["sensor-sf-north"].salinity + " %"
                        : "Loading..."}
                    </h1>
                  </div>
                </ColumnLayout>
              </Container>
            </Grid>
          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header="Split panel header">
            Split panel content
          </SplitPanel>
        }
      />
    </>
  );
}

export default DashboardBackend;
